<template>
  <div class="content-wrapper">
    <div class="content-heading">
      <div class="pull-right">
        <div class="btn-group">
          <!--<el-button type="inverse" class="pull-right">-->
            <!--<font-awesome-icon icon="reply"></font-awesome-icon>-->
          <!--</el-button>-->
          <el-button-group class="task-action">
            <el-button @click="showRejectTask()" type="danger">عدم تایید</el-button>
            <el-button @click="cancel()" type="inverse">انصراف</el-button>
            <el-button @click="doneTask()" type="primary">تایید</el-button>
            <el-button @click="temporaryDoneTask()">ثبت موقت</el-button>
          </el-button-group>
        </div>
      </div>
      <span>وظایف و کارها</span>
      <small>{{task.caption}}</small>
    </div>
    <div class="container-fluid">
      <div class="q-section row">
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-body">
              <amn-form :model="model"
                        :rules="modelRules"
                        :ref="formStructure.key" label-width="120px"
                        class="amn-form">
                <form-generator :formStructure="formStructure" v-model="model"></form-generator>
              </amn-form>
            </div>
            <!--<div class="panel-footer clearfix">-->
            <!--</div>-->
          </div>
        </div>

        <el-dialog title="" :close-on-click-modal="false" :visible.sync="rejectTaskDialog">
          <el-form :model="rejectTask" :rules="rejectTaskRules" ref="rejectTask" label-width="120px">
            <amn-form-item label="ارجاع به مرحله" prop="task">
              <el-radio-group v-model="rejectTask.task">
                <el-radio v-for="t in task.availableReturnTasks" :key="t.key" :label="t.key">{{t.caption}}<br></el-radio>
              </el-radio-group>
            </amn-form-item>

            <amn-form-item label="دلایل ارجاع" prop="note">
              <el-input
                type="textarea"
                :rows="3"
                placeholder=""
                v-model="rejectTask.note">
              </el-input>
            </amn-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer clearfix">
            <el-button-group class="task-action">
              <el-button @click="rejectTaskDialog = false" type="inverse">انصراف</el-button>
              <el-button @click="rejectTaskTo()" type="danger">ارجاع پرونده</el-button>
            </el-button-group>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>

</template>

<script>
  import caller from '../../../../q-components/q-caller'

  export default {
    name: 'QTaskDetail',
    props: {
      taskKey: {required: true, type: String},
      instanceId: {required: true, type: String},
      activityInstanceId: {required: true, type: String},
    },
    data() {
      return {
        task: {},
        model: {},
        formStructure: {},
        availableReturnTasks: [],


        rejectTaskDialog: false,
        rejectTask: {
          task: '',
          note: ''
        },
        rejectTaskRules: {
          task: [
            {required: true, message: 'فعالیت مورد نظر را انتخاب کنید', trigger: 'change'},
          ],
          note: [
            {required: true, message: 'شرح و دلایل ارجاع را وارد کنید', trigger: 'blur'},
          ]
        },
      };
    },
    computed: {
      modelRules() {
        let rules = {};
        for (let f in this.formStructure.fields) {
          let _field = this.formStructure.fields[f];
          let _rules = _field.rules;
          let fieldRules = [];
          for (let r in _rules) {
            fieldRules.push(_rules[r])
          }

          rules[_field.model] = fieldRules;
        }

        return rules;
      }
    },
    methods: {
      initialize(data) {
        this.model = data.model;
        this.task = data.task;
        this.formStructure = data.formStructure;
        this.availableReturnTasks = data.availableReturnTasks;
      },
      rejectTaskTo() {
        this.$refs['rejectTask'].validate((valid) => {
          if (valid) {
            this.rejectTaskDialog = false;
          } else {
            return false;
          }
        });
      },
      cancel() {
      },
      showRejectTask() {
        this.rejectTaskDialog = true;
      },
      doneTask() {
        this.$refs[this.formStructure.key].validate((valid) => {
          if (valid) {
            this.$delete('qasedak', 'DoneUserTask', {
              instanceId: this.instanceId,
              activityInstanceId: this.activityInstanceId,
              temporaryDone: false,
            }).then((res) => {
              window.notify.success('عملیات با موفقیت انجام شد.', res.message);
            });
          } else {
            window.notify.warning('اخطار', 'اطلاعات فرم را درست وارد کنید.');
          }
        });
      },
      temporaryDoneTask() {
        this.$refs[this.formStructure.key].validate((valid) => {
          if (valid) {
            this.$delete('qasedak', 'DoneUserTask', {
              instanceId: this.instanceId,
              activityInstanceId: this.activityInstanceId,
              temporaryDone: true,
            }).then((res) => {
              window.notify.success('عملیات با موفقیت انجام شد.', res.message);
            });
          } else {
            window.notify.warning('اخطار', 'اطلاعات فرم را درست وارد کنید.');
          }
        });
      },
    },
    watch: {}, //
    beforeRouteEnter(to, from, next) {
      caller.delegate('qasedak', 'GetUserTaskDetail', {
        taskKey: to.params.taskKey,
        instanceId: to.params.instanceId,
        activityInstanceId: to.params.activityInstanceId
      }).then((res) => {
        next(vm => vm.initialize(res));
      }).catch(() => {
        next();
      });
    },
  }
</script>

<style scoped>
  .task-action {
    float: left;
  }

  .task-detail {
    margin-left: 0px;
    overflow: auto;
  }
</style>
